import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getFrontendSettingSucceed, requestFailure } from '../actions'

export function* getFrontendSettingSaga(settingApi: {
  getFrontendSetting: (...args: any[]) => any
}) {
  try {
    const { data } = yield call(settingApi.getFrontendSetting)
    yield put(getFrontendSettingSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
